import { render, staticRenderFns } from "./SOV.vue?vue&type=template&id=cdcc5620&scoped=true"
import script from "./SOV.vue?vue&type=script&lang=js"
export * from "./SOV.vue?vue&type=script&lang=js"
import style0 from "./SOV.vue?vue&type=style&index=0&id=cdcc5620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcc5620",
  null
  
)

export default component.exports